import {
  OverlayArrow,
  Tooltip as AriaTooltip,
  TooltipTrigger,
} from 'react-aria-components'
import type { ReactElement, ReactNode } from 'react'
import type { Placement } from 'react-aria-components'
import { cx } from '../../cx'

export interface TooltipProps {
  title: ReactNode
  /** Must be a single focusable element — React Aria wires the trigger to it. */
  children: ReactElement
  placement?: Placement
  delay?: number
  className?: string
}

/**
 * React Aria handles what a CSS-only tooltip cannot: it shows on keyboard focus
 * as well as hover, hides on Escape, and binds the content with aria-describedby
 * so screen readers announce it. Positioning (flip, collision detection) is also
 * its job, which is why the skin no longer sets absolute offsets.
 */
export function Tooltip({
  title,
  children,
  placement = 'right',
  delay = 400,
  className,
}: TooltipProps) {
  return (
    <TooltipTrigger delay={delay}>
      {children}
      <AriaTooltip placement={placement} className={cx('bui-tip', className)} offset={8}>
        <OverlayArrow />
        {/* The skin (and the UI-scale zoom) sit on this span, not on the
            positioned tooltip element — see components.css deviation 5. */}
        <span className="bui-tip-body">{title}</span>
      </AriaTooltip>
    </TooltipTrigger>
  )
}
